import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { emptyArray } from 'ui-components/default-props/empty';
import { useIsVendorOr3PL } from '../../../../hooks/use-is-vendor-or-3pl';
import { useOnComponentMount } from '../../../../hooks/use-on-component-mount';
import { getStoreConfigurations } from '../../../../pages/settings/fulfillment-providers/api/packing-slip-sharing.api';
import { messages } from './messages';
import { PrintFormatSelector } from './print-format-selector';
import style from './print-modal-content.module.less';
import { getIsPackingSlipSharing, useFilteredStoreGuids } from '../../../../hooks/use-filtered-store-guids';

export const TemplateSection = ({ fulfillmentPlanIds = emptyArray, templates, onTemplateSelected, selectedTemplate }) => {
  const [isLoading, setIsLoading] = useAsyncSafeState(false);
  const [isDisabled, setIsDisabled] = useAsyncSafeState(false);
  const intl = useIntl();
  const isVendorOr3Pl = useIsVendorOr3PL();
  const { auctaneFulfillmentStoreGuids } = useFilteredStoreGuids(fulfillmentPlanIds);
  const storeDefaultOption = {
    name: intl.formatMessage(messages.defaultPackingSlipTemplateOption),
  };

  const fetchStoreConfigurations = useCallback(
    (storeGuids) => {
      setIsLoading(true);
      getStoreConfigurations({
        storeGuids,
      })
        .then((response) => {
          const isPackingSlipSharing = getIsPackingSlipSharing(response.data.storeConfigurations);
          setIsDisabled(isPackingSlipSharing);
        })
        .catch()
        .finally(() => {
          setIsLoading(false);
        });
    },
    [setIsDisabled, setIsLoading],
  );

  useOnComponentMount(() => {
    if (isVendorOr3Pl && auctaneFulfillmentStoreGuids.length !== 0) {
      fetchStoreConfigurations(auctaneFulfillmentStoreGuids);
    }
  });

  return (
    <div className={style['template-section']}>
      <div className={style['top-level-heading']}>
        <FormattedMessage defaultMessage='Template' description='printModal.printingFormat' id='B2zsRO' />
      </div>
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <PrintFormatSelector
          availableFormats={templates}
          isDisabled={isDisabled}
          onFormatSelected={onTemplateSelected}
          selectedFormat={isDisabled ? storeDefaultOption : selectedTemplate}
        />
      )}
    </div>
  );
};

TemplateSection.propTypes = {
  fulfillmentPlanIds: PropTypes.array,
  templates: PropTypes.array.isRequired,
  onTemplateSelected: PropTypes.func.isRequired,
  selectedTemplate: PropTypes.object.isRequired,
};
